import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  ChangeSubscriptionPlanOrderResponse,
  ChangeSubscriptionPlanRequest,
  ChangeSubscriptionPlanResponse,
} from "~/types/teacher/payment/subscriptions";

class TeacherPaymentSubscriptionModule extends HttpFactory {
  async getChangeSubscriptionPreview(
    targetSubscriptionPlanId: string,
  ): Promise<ChangeSubscriptionPlanResponse> {
    return await this.get(
      `${ENDPOINTS.PAYMENT.CHANGE_SUBSCRIPTION_PLAN}?target-subscription-plan-id=${targetSubscriptionPlanId}`,
    );
  }

  async changeSubscriptionPlan(
    payload: ChangeSubscriptionPlanRequest,
  ): Promise<ChangeSubscriptionPlanOrderResponse> {
    return await this.post(
      `${ENDPOINTS.PAYMENT.CHANGE_SUBSCRIPTION_PLAN}`,
      payload,
    );
  }
}

export { TeacherPaymentSubscriptionModule };
